// hide_thread_navbar: a phone's bottom navbar leaves thread panels. The
// thread's reply composer (the bottom_editor pill) stands on the navbar
// otherwise; with the feature the pill takes the panel's foot on its own and
// the navbar shows on streams and the other panels only. Per-user, so the two
// feet can be compared on a device before either is the default.

import { userHasFeature } from 'refactor/hooks/useUserHasFeature'

export const HIDE_THREAD_NAVBAR_FEATURE = 'hide_thread_navbar'

export function hideThreadNavbarEnabled(): boolean {
    return userHasFeature(HIDE_THREAD_NAVBAR_FEATURE)
}

// Whether the centered panel goes without the navbar for being a thread. Only
// a phone has the navbar (desktop threads under the pill lose theirs already;
// see resolveBottomControlsUnderEditor), and only a thread panel — one
// filtered to a quest — with a mounted replacement pill is the feature's.
export function shouldHideThreadNavigation({
    enabled = false,
    isMobile = false,
    isThreadPanel = false,
    bottomEditorMounted = false,
}: {
    enabled?: boolean
    isMobile?: boolean
    isThreadPanel?: boolean
    bottomEditorMounted?: boolean
} = {}): boolean {
    return Boolean(enabled && isMobile && isThreadPanel && bottomEditorMounted)
}
